<template lang="html">
  <div class="detailed-report text--primary printable">
    <div class="detailed-report-meta">
      Generated at {{now}}
    </div>
    <div class="detailed-report__section">
      <div class="detailed-report__section-title text-center">
        Detailed Report Total
      </div>
      <div class="detailed-report__section-value">
        {{date}}
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title text-center">
        {{orgName}}
      </div>
      <div class="detailed-report__section-value">
        org.nr. {{orgNumber}}
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Sales by payment method
      </div>
      <div class="detailed-report__section-data">
        <table class="bold-last">
          <thead>
          </thead>
          <tbody>
            <tr v-for="group in paymentsByPaymentMethod" :key="group.method">
              <td>{{group.method}}</td>
              <td class="right no-break">{{group.payments.reduce((a, payment) => a + payment.amount, 0).toFixed(2)}}&nbsp;SEK</td>
            </tr>
            <tr>
              <td>Total</td>
              <td class="right no-break">{{totalGross.toFixed(2)}}&nbsp;SEK</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Sales by item (net)
      </div>
      <div class="detailed-report__section-data">
        <table>
          <thead>
          </thead>
          <tbody>
            <tr v-for="group in itemsByItem" :key="group.itemId">
              <td>{{group.operatorName || 'Unknown'}}</td>
              <td>{{group.itemgroupName || 'Unknown'}}</td>
              <td>{{group.title || 'Unknown'}}</td>
              <td class="right">{{group.items.length}}</td>
              <td class="right no-break">{{group.items.reduce((a, item) => a + getNet(item.price, item.vat), 0).toFixed(2)}}&nbsp;SEK</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Sales by VAT rate (net)
      </div>
      <div class="detailed-report__section-data">
        <table>
          <thead>
          </thead>
          <tbody>
            <tr v-for="group in itemsByVat" :key="group.vat">
              <td>VAT {{group.vat}}%</td>
              <td class="right no-break">{{group.items.reduce((a, item) => a + getNet(item.price, item.vat), 0).toFixed(2)}}&nbsp;SEK</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="detailed-report__section">
      <div class="detailed-report__section-title">
        Total
      </div>
      <div class="detailed-report__section-data">
        <table class="bold-last">
          <thead>
          </thead>
          <tbody>
            <tr>
              <td>Total net</td>
              <td class="right no-break">{{totalNet.toFixed(2)}}&nbsp;SEK</td>
            </tr>
            <tr v-for="group in totalVats" :key="group.vat">
              <td>VAT {{group.vat}}%</td>
              <td class="right no-break">{{group.amount.toFixed(2)}}&nbsp;SEK</td>
            </tr>
            <tr>
              <td>Total gross</td>
              <td class="right no-break">{{totalGross.toFixed(2)}}&nbsp;SEK</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
  props: {
    payments: {
      type: Array
    },
    date: {
      type: String
    },
    orgName: {
      type: String
    },
    orgNumber: {
      type: String
    }
  },
  data () {
    return {};
  },
  computed: {
    now () {
      // eslint-disable-next-line no-unused-vars
      var trigger = this.items;
      return moment().format('YYYY-MM-DD HH:mm:ss');
    },
    items () {
      var result = [];
      this.payments.forEach((payment) => {
        var items = payment.items || [];
        items.forEach((item) => {
          item.operatorName = payment.operatorName;
        });
        result = result.concat(items);
      });
      return result;
    },
    paymentsByPaymentMethod () {
      var result = {};
      this.payments.forEach((payment) => {
        var paymentType = payment.paymentType || 'Unknown';
        if (!(paymentType in result)) {
          result[paymentType] = [];
        }
        result[paymentType].push(payment);
      });
      result = Object.keys(result)
        .sort()
        .map((key) => {
          return {
            method: key,
            payments: result[key]
          };
        });
      return result;
    },
    itemsByItem () {
      var result = {};
      this.items.forEach((item) => {
        var itemId = item.id || 'Unknown';
        if (!(itemId in result)) {
          result[itemId] = [];
        }
        result[itemId].push(item);
      });
      result = Object.keys(result).map((key) => {
        return {
          title: result[key][0].title,
          itemId: result[key][0].itemId,
          itemgroupName: result[key][0].itemgroupName,
          operatorName: result[key][0].operatorName,
          items: result[key]
        }
      });
      this.sortArrayByKey(result, 'title');
      this.sortArrayByKey(result, 'itemgroupName');
      return result;
    },
    itemsByVat () {
      var result = {};
      this.items.forEach((item) => {
        var vat = '' + (item.vat || 'Unknown');

        if (!(vat in result)) {
          result[vat] = [];
        }
        result[vat].push(item);
      });
      result = Object.keys(result).map((key) => {
        return {
          vat: result[key][0].vat,
          items: result[key]
        }
      });
      this.sortArrayByKey(result, 'vat');
      return result;
    },
    totalNet () {
      return this.items
        .reduce((a, item) => a + this.getNet(item.price, item.vat), 0);
    },
    totalGross () {
      return this.items.reduce((a, item) => a + item.price, 0);
    },
    totalVats () {
      return this.itemsByVat.map((group) => {
        return {
          vat: group.vat,
          amount: group.items.reduce((a, item) => a + this.getVAT(item.price, item.vat), 0)
        };
      });
    }
  },
  methods: {
    getNet (amount, vat) {
      // Get amount excl. VAT
      return amount / (1 + vat/100.0);
    },
    getVAT (amount, vat) {
      // Get VAT amount
      return this.getNet(amount, vat) * (vat/100.0);
    },
    sortArrayByKey (array, key) {
      array.sort((a, b) => {
        if (a[key] > b[key]) {
          return 1;
        } else if (a[key] < b[key]) {
          return -1;
        }
        return 0;
      });
      return array;
    }
  }
}
</script>

<style lang="css" scoped>
.detailed-report-meta {
  font-size: 0.8rem;
  margin-bottom: 1.5rem;
}
.detailed-report__section {
  margin-bottom: 1rem;
}
.detailed-report__section-title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0.2rem;
}
.detailed-report__section-title.text-center {
  text-align: center;
}
.detailed-report__section-value {
  font-size: 0.9rem;
  text-align: center;
}
.detailed-report__section-data {}
.detailed-report__section-data table {
  width: 100%;
}
.detailed-report__section-data table td:not(:last-of-type) {
  padding-right: 0.6rem;
}
.detailed-report__section-data table td.right {
  text-align: right;
}
.detailed-report__section-data table td.no-break {
  white-space: nowrap;
}
.detailed-report__section-data table.bold-last tr:last-of-type {
  font-weight: bold;
}
</style>
